import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { ParentScrollTracking } from "../../../../utils/scroll-tracking";
import {
    JswCollaborateSection,
    AiSection,
    JswDoubleFeatureSection,
    TestimonialSection,
    ClosingBanner,
    BuildAndSupportDoubleFeatureSection,
    IntegrationsSection,
    HeroSection,
    LogoBanner,
    AirCanadaLogo,
    CanvaLogo,
    DominosLogo,
    FordLogo,
    NasaLogo,
    VisaLogo
} from "../sections/productionized/logged-out-or-no-jira";
import { Footer } from "../sections/productionized/logged-out-or-no-jira/footer";
import JiraSoftwareNav from "../sections/productionized/software-jira-navbar";

export const LoggedOutOrNoJiraProductTourOverview = () => {
    const intl = useIntl();

    const sectionContainerStyles = css({
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
    });

    const closingBannerContent = {
        text: intl.formatMessage({
            id: "jira-product-tour.closing-banner.header-text",
            defaultMessage:
                "No matter what you're trying to dream up, Jira helps you get it done"
        }),
        imgUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/closing-banner-graphic.webp",
        altText: "hand image",
        starImageUrl:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/artboard-stars.webp",
        starsAltText: "star image",
        buttonText: intl.formatMessage({
            id: "jira-product-tour.closing-banner.button-text",
            defaultMessage: "Get Jira free"
        }),
        ctaButtonUrl: "/try/cloud/signup?bundle=jira-software"
    };

    const svgArray = [
        NasaLogo,
        AirCanadaLogo,
        VisaLogo,
        CanvaLogo,
        DominosLogo,
        FordLogo
    ];

    return (
        <div>
            <JiraSoftwareNav />
            <div css={sectionContainerStyles}>
                <ParentScrollTracking
                    scrollTrackingEnabled={true}
                    pageId="Jira"
                >
                    <HeroSection />
                    <LogoBanner svgArray={svgArray} />
                    <JswCollaborateSection />
                    <AiSection />
                    <BuildAndSupportDoubleFeatureSection />
                    <JswDoubleFeatureSection />
                    <IntegrationsSection />
                    <TestimonialSection />
                    <ClosingBanner {...closingBannerContent} />
                    <Footer />
                </ParentScrollTracking>
            </div>
        </div>
    );
};
